export default {"src":"/_next/static/media/white_floorplan_hover.8fc7baac.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};